import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { msg } from './messages.js';

/**
 * Consistent header for pushed (non-tab) screens: a back affordance plus the
 * screen title. Tab destinations keep their own plain headers.
 */
export function StackHeader({
  title,
  fallback = '/',
}: {
  title: string;
  fallback?: string;
}): JSX.Element {
  const navigate = useNavigate();
  const back = (): void => {
    // Prefer in-app history; fall back to a sensible home when opened cold.
    if (window.history.length > 1) navigate(-1);
    else navigate(fallback);
  };

  return (
    <header className="stack-header">
      <button
        type="button"
        className="stack-header__back"
        aria-label={msg.common.back}
        onClick={back}
      >
        <ChevronLeft size={24} aria-hidden="true" />
      </button>
      <h1 className="stack-header__title numeral">{title}</h1>
    </header>
  );
}
